var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationalMentoring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38119 13.0908L2.36579 12.866L2.18713 12.7286L0.5 11.4313V8.92102H7.5V11.4313L5.81287 12.7286L5.63421 12.866L5.61881 13.0908L5.18011 19.5H2.81989L2.38119 13.0908Z",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3812 13.0908L14.3658 12.866L14.1871 12.7286L12.5 11.4313V8.92102H19.5V11.4313L17.8129 12.7286L17.6342 12.866L17.6188 13.0908L17.1801 19.5H14.8199L14.3812 13.0908Z",
    stroke: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.42102C4 10.9473 4 11.5789 4 11.5789",
    stroke: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.42102C16 10.9473 16 11.5789 16 11.5789",
    stroke: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 5,
    r: 1.5,
    stroke: "current"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 1.5,
    stroke: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 6.71804H7.5V0.5H12.5V6.71804H11.2H10.9925L10.846 6.86493L10 7.71306L9.154 6.86493L9.00747 6.71804H8.8Z",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationalMentoring);
export default __webpack_public_path__ + "static/media/situational-mentoring.16a80e282347f121ae953abdc7bd64a2.svg";
export { ForwardRef as ReactComponent };